<template>
  <div class="max-h-[98vh]" :key="pageTitle">
    <PageTitleVue
      :sub-title="subTitle" 
      :key="subTitle"
    >
      {{ pageTitle }}
    </PageTitleVue>

    <Transition mode="out-in">
      <div class="overflow-hidden">
        <keep-alive>
          <component :is="componentActive"></component>
        </keep-alive>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import PageTitleVue from "@/components/Titles/PageTitle.vue";
import AsosService from "./service/asos.service";
import { onBeforeMount } from "vue";
import { storeApp } from "@/store";
import { dataAso } from "./store";
import { computed } from "vue";
import { markRaw } from "vue";
import MedicosList from "./layout/pages/MedicosList.vue";

const componentActive = computed(() => dataAso.getters.getActiveComponent);
const subTitle = computed(() => dataAso.getters.getPageSubTitle);

const pageTitle = computed(() => {
  if(dataAso.state.componentActive.__name == 'MedicosList') {
    dataAso.dispatch("setPageTitle",    "Médicos");
    dataAso.dispatch("setPageSubTitle", "Gerencie sua equipe com facilidade");
  }

  if(dataAso.state.componentActive.__name == 'SectorForm') {
    dataAso.dispatch("setPageTitle", "Nova Consulta");
    dataAso.dispatch("setPageSubTitle", "Agende uma nova consulta");
  }

  if(dataAso.state.componentActive.__name == 'ConsultasList') {
    dataAso.dispatch("setPageTitle", "Consultas");
    dataAso.dispatch("setPageSubTitle", "Gerencie todas as consultas agendadas");
  }

  if(dataAso.state.componentActive.__name == 'DoctorForm') {
    dataAso.dispatch("setPageTitle", "Novo médico");
    dataAso.dispatch("setPageSubTitle", "Faça o cadastro de uma novo profissional");
  }
  
  return dataAso.getters.getTitle
});

onBeforeMount(async () => {
  storeApp.state.loading = true;
  
  if(dataAso.state.componentActive == undefined)
    dataAso.dispatch("setComponentActive", markRaw(MedicosList));
 
  await getCities();
  await getDoctors();
  await getPacientes();

  storeApp.state.loading = false;
});

async function getCities() {
  await AsosService.getAllCities()
    .then((res) => {
      dataAso.dispatch("setAllCities", res.data);
    })
    .catch((err) => {
      console.log(err);
    });
}

async function getDoctors() {
  await AsosService.getAllMedicos()
    .then((res) => {
      dataAso.dispatch("setAllDocs", res.data);
    })
    .catch((err) => {
      console.log(err);
    });
}

async function getPacientes() {
  await AsosService.getAllPacientes()
    .then((res) => {
      dataAso.dispatch("setAllPacientes", res.data);
    })
    .catch((err) => {
      console.log(err);
    });
}

</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
